// 3rd Party
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Components
import { Div, P } from 'common/styles/oc-styled-components';

import { colors, ratingColors } from 'common/styles/style-constants';

import RatingStars from '../../../common/components/RatingStars/RatingStars';
import VerifiedReviewBadge from '../svgs/VerifiedReviewBadge';

// Other

import {
  ReviewCardWrapper,
  ReviewCardContainer,
  ReviewDataContainerDesktop,
  ReviewDataContainerMobile,
} from './styled-components';

function ReviewCard(props) {
  if (!props.review) return null;
  const { description, createdAt, overallRating } = props.review;
  const dateReadable = moment(createdAt).format('LL');
  const color = ratingColors[overallRating];

  return (
    <ReviewCardWrapper
      align="top"
      borderBottom={props.finalReview ? '' : `1px solid ${colors.silver}`}
      margin={props.index === 0 ? '40px 0 0 0' : '60px 0 0 0'}
      as="article"
    >
      <ReviewCardContainer width="30%">
        <Div>
          <RatingStars
            averageRating={overallRating}
            sideLength="30px"
            starColor={color}
          />
          <ReviewDataContainerDesktop>
            <P fontSize="14px" margin="10px 0 0 0">
              Reviewed on
            </P>
            <P fontSize="16px" margin="0 0 10px 0">
              {dateReadable}
            </P>
          </ReviewDataContainerDesktop>
        </Div>
        <VerifiedReviewBadge />
      </ReviewCardContainer>
      <ReviewDataContainerMobile margin="5px 0 10px 0">
        <P fontSize="14px">Reviewed {dateReadable}</P>
      </ReviewDataContainerMobile>
      <ReviewCardContainer margin="0 0 0 50px" width="70%">
        <P fontSize="16px">{description}</P>
      </ReviewCardContainer>
    </ReviewCardWrapper>
  );
}

ReviewCard.propTypes = {
  finalReview: PropTypes.bool,
  index: PropTypes.number,
  review: PropTypes.object,
};

export default ReviewCard;
